module.exports = __webpack_public_path__ + "static/media/click-12.501b26d6.mp3";